import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import LoadingScreen from "@/components/LoadingScreen";
import PublicLayout from "@/components/PublicLayout";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Quiz from "@/pages/Quiz";
import Leaderboard from "@/pages/Leaderboard";
import Rules from "@/pages/Rules";
import Results from "@/pages/Results";
import Contact from "@/pages/Contact";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import LiveMonitor from "@/admin/LiveMonitor";
import Participants from "@/admin/Participants";
import Categories from "@/admin/Categories";
import Questions from "@/admin/Questions";
import Control from "@/admin/Control";
import AntiCheat from "@/admin/AntiCheat";
import Analytics from "@/admin/Analytics";
import Comms from "@/admin/Comms";
import Announcements from "@/admin/Announcements";
import AdminSettings from "@/admin/Settings";
import Logs from "@/admin/Logs";

function Shell() {
  const [loading, setLoading] = useState(true);
  const { config } = useApp();

  return (
    <div className="App">
      {loading && <LoadingScreen logoUrl={config?.branding?.loading_logo_url || config?.branding?.logo_url} onDone={() => setLoading(false)} />}
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/quiz/:categoryId" element={<Quiz />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/results" element={<Results />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="live" element={<LiveMonitor />} />
            <Route path="participants" element={<Participants />} />
            <Route path="categories" element={<Categories />} />
            <Route path="questions" element={<Questions />} />
            <Route path="control" element={<Control />} />
            <Route path="anticheat" element={<AntiCheat />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="comms" element={<Comms />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="logs" element={<Logs />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}

export default App;
